import { useHistory } from "react-router";
import useSyncedLocalStorage from "@avinet/adaptive-ui-core/hooks/useSyncedLocalStorage";
import Grow from "@avinet/adaptive-ui-core/layout/Grow";
import Row from "@avinet/adaptive-ui-core/layout/Row";
import ThemeModeSwitch from "@avinet/adaptive-ui-core/ui/ThemeModeSwitch";
import { useTranslate } from "@avinet/adaptive-ui-translate";
import { SESSION_TOKEN_KEY } from "../config/config";
import useProfile from "../hooks/useProfile";
import { setLoggedInUser } from "../utils/login";
import { Icon } from "./Icon";
import { Profile } from "./Profile";
import "./Header.scss";

const Header = () => {
  const t = useTranslate("Header");
  const profile = useProfile();
  const [, setSessionToken] = useSyncedLocalStorage(SESSION_TOKEN_KEY);
  const history = useHistory();
  const [userLang, setUserLang] = useSyncedLocalStorage("lang");

  return (
    <header className="page-header">
      <div>
        <img
          className="logo"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
          alt=""
        />
      </div>
      <div>
        <img
          className="symbol"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
          alt=""
        />
      </div>
      <Row className="user">
        <Grow />
        <button
          className="btn tertiary language small"
          onClick={() => setUserLang("en")}
          title="English"
          disabled={userLang == "en"}
        >
          EN
        </button>
        <button
          className="btn tertiary language small"
          onClick={() => setUserLang("no")}
          title="Norsk"
          disabled={userLang != "en"}
        >
          NO
        </button>
        <ThemeModeSwitch />
        {profile && (
          <>
            <Profile profile={profile} />
            <button
              type="button"
              className="btn-link logout"
              onClick={() => {
                setSessionToken("");
                setLoggedInUser(null);
                history.push("/survey");
              }}
              title={t("logout")}
            >
              <Icon name="signOut" />
            </button>
          </>
        )}
      </Row>
    </header>
  );
};

export default Header;
